import React, { useState }  from 'react';
import { Button, Popup }    from 'semantic-ui-react';

import FormModal        from './FormModal';

// -----------------------------------------------------
// Settings
// -----------------------------------------------------

const title = 'Edit Family Member';

// -----------------------------------------------------
// Component Definition
// -----------------------------------------------------

const AddButton = ({clientId, member}) => {
  const [opened, setOpened] = useState(false);

  const handleClick = (evt) => {
    evt.preventDefault();
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  const Btn = <Button icon='pencil'
                      size='mini'
                      basic
                      color='blue'
                      onClick={ handleClick } />;

  return (
    <>
      <FormModal title={ title }
                opened={ opened }
                clientId={ clientId }
                member={ member }
                onClose={ handleClose } />

      <Popup  trigger={ Btn }
              content={ title }
              position='top right' />
    </>
  );
};

// -----------------------------------------------------
// Exports
// -----------------------------------------------------

export default AddButton;
